import { render, staticRenderFns } from "./FeedbacksFilter.vue?vue&type=template&id=4e455410&scoped=true"
var script = {}
import style0 from "./FeedbacksFilter.vue?vue&type=style&index=0&id=4e455410&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e455410",
  null
  
)

export default component.exports